var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 322",
    style: {
      enableBackground: "new 0 0 330 322"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#333333;stroke-width:3.961;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.7,200.7c0,0-0.9-12.6-2.1-18.2c-4.9,3.8-8,6.1-13.5,8.4c-6.2,2.5-12.7,2.9-19.8,2.7 c0,7.4-0.4,16.7-0.2,23.9c7.1-0.1,14.1-1.7,20.5-4.7C144.7,209.8,152.1,205.3,153.7,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.2,188.5c-0.7,3.9-3.4,17.2,3.8,13.1c5.4-3.1,8.9-10.1,13.6-13.9c0.6,8.1-4.6,18.3-0.3,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.4,171.8c0,0,7.1-17.2,11.3-25.7c4-8,10.2-19.2,15.5-27c-4.4-3.7-21.2-13.3-25.5-16.5 c15-6.4,29.2-10.5,43.7-12.3c12.5-1.5,32.5-1.2,29.8,17.1c-1,6.9-4.6,14.4-8.5,20.4c7.5-1.8,25.7-1.2,24,11.3 c-1.6,12-21.8,9.4-29.1,6.4c0,0-5.7,20-6.7,27.1c-1.2,8.1-2.9,21.2-2.9,21.2L208.4,171.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.3,198.4c4.6,0.5,10.9,26.9,20.4,8.2c11.3-12.8,24.3-28.3,31.7-35.4c3,4.6,17.4-8.4,26.8-2.9 c22.7-25.6,15.6,28.6,26.6,26c0,0-0.5,10.6,1.3,12.8s9.4,8.3,12.8,11.6c8.9,9,16.7,24.3,20.7,36.3c2.2,6.5,4.5,17.6,5.4,24.2 l-42.8-4.6c-3.6,11.3-15.7,21.2-20.3,15.9c-4.6-5.3,3.6-8.9,6.5-4.4c3,4.5,1.1,12.9-12.9,12.9c-23.1,0-39-28.9-48-44.1 c-6.7-11.4-13.1-24.5-16.3-34.7c-3.1-10.2,92,62.8,64.2,78.8c-29.4,16.9-105.7,7.7-105.7,7.7c0-5.4-7.9-21.5-11.6-31.2 c-3.8-9.7-5.7-19.8,2.1-25.7c-4.5-4.2-6.5-12.3-6.1-18.5c0.3-5.4,2.7-11.9,7.9-14.1l33.5-34.9L155.3,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,195c-10.6,0-31,4.5-35.9,11.2c-4.9,6.8,0.7,31.2,2.9,39.2c4.2,15.2,7.5,31.8,13.8,46.2 c3.7,8.6,6.3,23.1,13,29.6l87.4-14.4l-13.7-37.3c-4.8,2.1-10,3-15.3,2.7c-15.3-1-22.6-17.8-28-30.9c-4-9.7-7.1-19.6-10.9-29.2 C55.7,206.7,49.9,195.8,44.6,195c-0.8-6.1-2-12.1-3.5-18c-10.8-1.5-21.7-1.3-32.4,0.5c0.5,4.8,3.7,25.4,3.7,25.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,144.7c2.1-7.5,10-10.8,17.3-15.2c4-10.2,7.7-23.6,13.9-22.1s-1.8,28.2-5.5,38.4c-2.6,7-6.2,12-7.5,18.9 c-0.9,5.1-1.8,12.4-1.8,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.7,186.6l-0.5,6.9c1.9,1.2,34.6,2.1,31.2-9.6c-2-6.8,2.7-16.6,5.7-41.5c0.5-4.3,0-7.9-2-11.8 c-2-3.9-5.1-6.6-18.7-13.9c-13.1-7-12.4-5.7-19.1-9.8c-7.1-4.3-12-10.7-20.3-15c-7.4-3.8-9.4-2.3-11.7-0.5 c-2.7,2.1-1.3,9.1,1.2,13.6c0.8,1.5,2.8,4.5,11.7,10.2c3.6,2.3,8.8,5.3,15.5,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.7,174.1l-31.4,1.6c-2.9-12.9-0.6-25.3-3.4-37.8c-2.5-11-6-25-2.3-35.7C5.7,96.3,17.1,52,24,50.8l5.5,0.1 l11.3-18.4l7.9-1.7c0,0,21.6,6.4,21.9,10s4.6,2.4,1.8,11.6S54,105.1,54,105.1l2.2,16.4L40.7,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,96.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.7,179.1l-6.2-4.5l-0.5,1c-4-0.2-6.7,0.8-10.5-2.1c-3.5-2.7-6.2-8.9-5.8-13.4l-1,2.8 c-6.2-4.1-9.1-20.7,0.8-21.3l1.7,0.2c-2.2-8.8,0.8-13.5,8.8-16.4c6.9-2.5,16.4-5.5,23.1-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,130.6c2.6-26.7,10-47.5,18.5-72.9c1.6-4.7,6.1-14.9,9.9-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.4,138.1c0.8-0.6,5.4-0.7,5.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.8,95.8c-0.5-0.4-1-0.7-1.6-1.1c-0.1,0-0.2-0.1-0.3-0.1c0.3-5.6-4.7-9.5-9.8-10.5 c-6.4-1.3-13.7,1.1-19.4-2.9c-1.4-1-0.6,1.1,0,2.5c4.7,10.6,13.5,14.1,24.3,15c-2.6,3-3.6,7.2-3.6,11.2 c-0.1,6.5,2.1,14.7-3.6,19.6c-1.4,1.2,0.3,3.6,1.9,2.6c2.3-1.4,4.3-3.1,6.3-5c3.6-0.3,7.3,0,10.8,0.8c0.4-0.8,0.7-1.7,1-2.5 C293.9,116.4,294.5,101.2,284.8,95.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154,199.2c0,0-0.9-12.6-2.1-18.2c-4.9,3.8-8,6.1-13.5,8.4c-6.2,2.5-12.7,2.9-19.8,2.7 c0,7.4-0.4,16.7-0.2,23.9c7.1-0.1,14.1-1.7,20.5-4.7C145.1,208.3,152.4,203.7,154,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.5,187c-0.7,3.9-3.4,17.2,3.8,13.1c5.4-3.1,8.9-10.1,13.6-13.9c0.6,8.1-4.6,18.3-0.3,26.4 c4,7.6,16,3,22.4,0.5c4.5-1.7,12.9-5,17.4-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.8,170.3c0,0,7.1-17.2,11.3-25.7c4-8,10.2-19.2,15.5-27c-4.4-3.7-21.2-13.3-25.5-16.5 c15-6.4,29.2-10.5,43.7-12.3c12.5-1.5,32.5-1.2,29.8,17.1c-1,6.9-4.6,14.4-8.5,20.4c7.5-1.8,25.7-1.2,24,11.3 c-1.6,12-21.8,9.4-29.1,6.4c0,0-5.7,20-6.7,27.1c-1.2,8.1-2.9,21.2-2.9,21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.3,127.6c1.7,1.6,6.3,1.9,8.5,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.1,108.9c-0.7,1.4-1.8,3.7-1.8,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.8,111.3c-0.7,1.4-1.8,3.7-1.8,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.4,215.9c-5.2,2.2-7.6,8.6-7.9,14.1c-0.3,6.2,1.6,14.3,6.1,18.5c-7.8,5.9-5.9,16-2.1,25.7 c3.8,9.7,11.6,25.8,11.6,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154,199.2c7.9-2.3,10.4,9.5,13.6,19.7c3.1,10.2,9.5,23.2,16.3,34.7c8.9,15.2,24.9,44.1,48,44.1 c14.1,0,15.9-8.4,12.9-12.9c-3-4.5-11.2-0.9-6.5,4.4c4.6,5.3,16.7-4.6,20.3-15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.9,216c2.9-3.7,5.9-7.3,9.1-10.9c11.3-12.8,24.3-28.3,31.7-35.4c3,4.6,8.7,9.9,18.1,15.3 c9.5,5.5,24.3,10.4,35.3,7.8c0,0-0.5,10.6,1.3,12.8s9.4,8.3,12.8,11.6c8.9,9,16.7,24.3,20.7,36.3c2.2,6.5,4.5,17.6,5.4,24.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,201.4c0,0-3.2-20.6-3.7-25.4c10.7-1.8,21.6-1.9,32.4-0.5c1.6,5.9,2.7,11.9,3.5,18 c5.3,0.7,11.1,11.6,13.2,17c3.8,9.7,6.9,19.6,10.9,29.2c5.4,13.1,12.7,29.8,28,30.9c5.2,0.3,10.5-0.6,15.3-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,193.5c-10.6,0-31,4.5-35.9,11.2c-4.9,6.8,0.7,31.2,2.9,39.2c4.2,15.2,7.5,31.8,13.8,46.2 c3.7,8.6,6.3,23.1,13,29.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,143.2c2.1-7.5,10-10.8,17.3-15.2c4-10.2,7.7-23.6,13.9-22.1s-1.8,28.2-5.5,38.4c-2.6,7-6.2,12-7.5,18.9 c-0.9,5.1-1.8,12.4-1.8,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.3,191l-1.3-14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.7,176.4c-7.5,2.4-15.3-9.3-8.1-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,139.4c0,0-7.4-1.9-10.9-4.5c-5-3.8-3.2-11.2-2.7-16.8c2-23.4,8.1-43.5,17.1-64.8 c2.6-6.2,5.9-14.1,10.1-19.2c4.3-5.3,10.3-3.5,16.7-1s13.5,5,16.1,9.8c2.1,3.9,0.7,10-3.4,20.8c-3.7,9.7-8.8,22.6-14.9,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.3,174.1c-4-0.2-6.7,0.8-10.5-2.1c-3.5-2.7-6.2-8.9-5.8-13.4c0.5-6.1,18-18.3,21.4-13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,174.1c-2.9-12.9-0.6-25.3-3.4-37.8c-2.5-11-6-25-2.3-35.7c2-5.8,6.2-7.4,10.6-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,155.3c-1.9-8.7-1.7-13.1,5.8-18.1c4.3-2.9,14.2-8,18.6-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.6,94.7c-1.7-1.8-1.1-8.4,0.4-10.9c1.8-3.2,8.1-7.4,11.8-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.6,140.2c-2.2-8.8,0.8-13.5,8.8-16.4c6.9-2.5,16.4-5.5,23.1-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,80.5c-1.9-6.5,3-14.6,11.3-13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.1,161.3c-6.2-4.1-9.1-20.7,0.8-21.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,68.3C15.3,61,22,46.6,29.5,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.1,122c-4.9-2.3-10.9-5.1-15.5-8.2c-4.2-2.8-8.8-6.1-11.7-10.2C82.3,100,79,93.5,83.7,90 c5.2-4,10.5,1.3,14.1,4.3c5.3,4.5,11.8,7.7,17.9,11.2c5.7,3.3,12.9,6.4,19.1,9.8c11.9,6.4,21.9,10.1,20.7,25.7 c-1,12.9-7.4,26.5-5.7,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,129.1c2.6-26.7,10-47.5,18.5-72.9c1.6-4.7,6.1-14.9,9.9-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.7,136.6c0.8-0.6,5.4-0.7,5.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.9,151.3c0.3,0.1,0.7,0.2,1,0.2c0.3,0,0.7-0.1,1-0.2c2.8-1.3,5.4-3.1,7.5-5.3c-2.5-0.4-5-1-7.4-1.9 C270,144,269,147.1,267.9,151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.2,94.3c-0.5-0.4-1-0.7-1.6-1.1c-0.1,0-0.2-0.1-0.3-0.1c0.3-5.6-4.7-9.5-9.8-10.5 c-6.4-1.3-13.7,1.1-19.4-2.9c-1.4-1-2.9,0.7-2.3,2.1c4.7,10.6,15.8,14.5,26.6,15.4c-2.6,3-3.6,7.2-3.6,11.2 c-0.1,6.5,2.1,14.7-3.6,19.6c-1.4,1.2,0.3,3.6,1.9,2.6c2.3-1.4,4.3-3.1,6.3-5c3.6-0.3,7.3,0,10.8,0.8c0.4-0.8,0.7-1.7,1-2.5 C294.3,114.9,294.9,99.7,285.2,94.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/Click.858bdf9b5449e0918b2c94c1446ad670.svg";
export { ForwardRef as ReactComponent };